module.exports = __webpack_public_path__ + "static/media/user-ico.a3030f19.svg";